// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"86362711","165":"06d88ac1"}[chunkId] + ".chunk.js";
};